/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
==========================================================================================*/

import state from "./state";
import getters from "./getters";

const mutations = {
    //auth request started
    auth_request(state) {
        state.loading = false;
    },

    //authorization successful
    auth_success(state, data) {
        state.loading = true;
        state.status = 'success';

        state.token = data.token;

        state.user_id = data.user_id;
        state.success_message = data.message ? data.message : false;
        state.message_type = 'main';

        state.frontend_notify.title = data.message ? data.message : '';
        state.frontend_notify.type = 'success';
    },

    //authorization failed
    auth_error(state, data) {
        state.loading = false;
        state.status = 'error';
        state.error_message = data.message ? data.message : false;
        state.message_type = 'login';

        // state.frontend_notify.title = data.message ? data.message : '';
        // state.frontend_notify.type = 'danger';
    },

    //login 2fa
    auth_2fa(state, message) {
        state.success_message = message ? message : false;
        state.message_type = 'loginConfirm';

        // state.frontend_notify.title = data.message ? data.message : '';
        // state.frontend_notify.type = 'success';
    },

    //resend login 2fa success
    resend_auth_2fa_success(state, data) {
        state.loading = false;
        state.status = 'success';
        state.success_message = data.message ? data.message : false;
        state.message_type = 'loginConfirm';
        state.confirmType = data.type;
        state.confirmEmail = data.email;

        // state.frontend_notify.title = data.message ? data.message : '';
        // state.frontend_notify.type = 'success';
    },

    //resend login 2fa error
    resend_auth_2fa_error(state, data) {
        state.loading = false;
        state.status = 'error';
        state.error_message = data.message ? data.message : false;
        state.message_type = 'loginConfirm';

        // state.frontend_notify.title = data.message ? data.message : '';
        // state.frontend_notify.type = 'danger';
    },

    //fetch first un auth screen
    fetch_first_un_auth_screen(state) {
        state.loading = true;
        state.status = 'success';
    },

    //first un auth screen fetched
    first_un_auth_screen_fetched(state, data) {
        state.loading = false;
        state.status = 'success';

        state.theme = data.themeSettings ? data.themeSettings : state.defaultTheme;
        state.basicOrganizationData = data.basicOrganizationData;
        state.currentTranslations = data.currentTranslations;
        state.activeLanguage = data.activeLanguage;
        state.local_active_language_id = data.activeLanguage.id;
        state.languageMenu = data.menus.languageMenu;
        state.countries = data.countries;
    },

    //first un auth screen fetch failed
    fetch_first_un_auth_screen_error(state) {
        state.loading = false;
    },

    //fetch first front page screen
    fetch_first_front_page_screen(state) {
        state.loading = true;
        state.status = 'success';
    },

    //first un front page fetched
    first_front_page_screen_fetched(state, data) {
        state.loading = false;
        state.status = 'success';

        if(!state.currentTranslations) {
            state.languageMenu = data.menus.languageMenu;
            state.basicOrganizationData = data.basicOrganizationData;
            state.currentTranslations = data.currentTranslations;
            state.local_active_language_id = data.activeLanguage.id;
            state.countries = data.countries;
        }

        state.user = data.user;
        state.profile = data.profile;
        state.profileImage = data.profileImage;
        state.profileImage_b = data.profileImage_b;
        state.profileImage_s = data.profileImage_s;
        state.coverImage = data.coverImage;
        state.coverImage_b = data.coverImage_b;
        state.coverImage_m = data.coverImage_m;
        state.coverImage_s = data.coverImage_s;
    },

    //first front page screen fetch failed
    fetch_first_front_page_screen_error(state) {
        state.loading = false;
    },

    //change active language
    change_active_language(state) {
        state.loading = false;
    },

    //change active language success
    active_language_changed(state, data) {
        state.loading = false;
        state.status = 'success';

        state.activeLanguage = data.activeLanguage;
        state.local_active_language_id = data.activeLanguage.id;
        state.currentTranslations = data.currentTranslations;
    },

    //fetch first auth screen
    fetch_first_auth_admin_screen(state) {
        state.loading = true;
    },

    //first auth screen fetched success
    first_auth_admin_screen_fetched(state, data) {
        state.loading = true;
        state.status = 'success';

        state.theme = data.themeSettings ? data.themeSettings : state.defaultTheme;
        state.basicOrganizationData = data.basicOrganizationData;
        state.organization_name = data.organization_name;
        state.activeLanguage = data.activeLanguage;
        state.currentTranslations = data.currentTranslations;
        state.user = data.user;
        state.profile = data.profile;
        state.profileImage = data.profileImage;
        state.profileImage_b = data.profileImage_b;
        state.profileImage_s = data.profileImage_s;
        state.coverImage = data.coverImage;
        state.coverImage_b = data.coverImage_b;
        state.coverImage_m = data.coverImage_m;
        state.coverImage_s = data.coverImage_s;
        state.languageMenu = data.menus.languageMenu;
        state.sidebarMenuAdminName = data.menus.sidebarMenuAdminName;
        state.sidebarMenuAdmin = data.menus.sidebarMenuAdmin;
        state.profileMenu = data.menus.profileMenu;
        state.searchable = data.searchable;
        state.staredPages = data.staredPages;
        state.countries = data.countries;
        state.tasksData = data.tasks;
    },

    //first auth screen fetched error
    fetch_first_auth_admin_screen_error(state) {
        state.status = '';
        state.loading = false;
        state.token = '';
    },

    //organization data updated
    organization_updated(state, data) {
        state.status = 'success';
        if (data.organization && data.organization.name !== null) {
            state.organization_name = data.organization.name;
        }

        if(data.status === 1) {
            if(data.organization){
                state.basicOrganizationData.logo = data.organization.logo;
                state.basicOrganizationData.logo_b = data.organization.logo_b;
                state.basicOrganizationData.logo_s = data.organization.logo_s;
                state.basicOrganizationData.logo_big = data.organization.logo_big;
                state.basicOrganizationData.logo_big_b = data.organization.logo_big_b;
                state.basicOrganizationData.logo_big_s = data.organization.logo_big_s;
            } else {
                if (data.logo !== null) {
                    state.basicOrganizationData.logo = data.logo;
                    state.basicOrganizationData.logo_b = data.logo_b;
                    state.basicOrganizationData.logo_s = data.logo_s;
                }

                if (data.logo_big !== null) {
                    state.basicOrganizationData.logo_big = data.logo_big;
                    state.basicOrganizationData.logo_big_b = data.logo_big_b;
                    state.basicOrganizationData.logo_big_s = data.logo_big_s;
                }
            }
        }
    },

    //profile data updated
    profile_updated(state, data) {
        if (data.payload) {
            if (data.payload.data.user !== null) {
                state.user.first_name = data.payload.data.user.first_name;
                state.user.last_name = data.payload.data.user.last_name;
            }

            if (data.payload.data.profile !== null) {
                state.profile.gender = data.payload.data.profile.gender;
                state.profile.birth_date = data.payload.data.profile.birth_date;
                state.profile.description = data.payload.data.profile.description;
                state.profile.address_country_id = data.payload.data.profile.address_country_id;
                state.profile.address_region = data.payload.data.profile.address_region;
                state.profile.address_city = data.payload.data.profile.address_city;
                state.profile.address_address = data.payload.data.profile.address_address;
                state.profile.address_post_code = data.payload.data.profile.address_post_code;
                state.profile.website = data.payload.data.profile.website;
                state.profile.facebook = data.payload.data.profile.facebook;
                state.profile.twitter = data.payload.data.profile.twitter;
                state.profile.instagram = data.payload.data.profile.instagram;
                state.profile.linkedin = data.payload.data.profile.linkedin;
            }
        } else {
            if (data.profileImage !== null) {
                state.profileImage = data.profileImage;
                state.profileImage_b = data.profileImage_b;
                state.profileImage_s = data.profileImage_s;
            }

            if (data.coverImage !== null) {
                state.coverImage = data.coverImage;
                state.coverImage_b = data.coverImage_b;
                state.coverImage_m = data.coverImage_m;
                state.coverImage_s = data.coverImage_s;
            }
        }
    },


    //password change success
    password_change_success(state, data) {
        state.loading = false;
        state.status = 'success';
        state.token = '';
        state.success_message = data.message ? data.message : false;
        state.message_type = 'confirm';
        state.confirmType = data.type;
        state.confirmEmail = data.email;
    },

    //password change confirm success
    password_change_confirm_success(state, data) {
        state.loading = true;
        state.status = 'success';
        state.token = data.token;
        state.success_message = data.message ? data.message : false;
        state.message_type = 'change_password_confirm';

        state.frontend_notify.title = data.message ? data.message : '';
        state.frontend_notify.type = 'success';
    },

    //password change error
    password_change_error(state, data) {
        state.loading = false;
        state.status = 'error';
        state.error_message = data.message ? data.message : false;
        state.message_type = 'change_password';
    },

    //password change confirm error
    password_change_confirm_error(state, data) {
        state.loading = false;
        state.status = 'error';
        state.error_message = data.message ? data.message : false;
        state.message_type = 'change_password_confirm';
    },

    //email change success
    email_change_success(state, data) {
        state.loading = false;
        state.status = 'success';
        state.token = '';
        state.success_message = data.message ? data.message : false;
        state.message_type = 'confirm';
        state.confirmType = data.type;
        state.confirmEmail = data.email;
    },

    //email change confirm success
    email_change_confirm_success(state, data) {
        state.loading = true;
        state.status = 'success';
        state.token = data.token;
        state.success_message = data.message ? data.message : false;
        state.message_type = 'change_email_confirm';

        state.frontend_notify.title = data.message ? data.message : '';
        state.frontend_notify.type = 'success';
    },

    //email change error
    email_change_error(state, data) {
        state.loading = false;
        state.status = 'error';
        state.error_message = data.message ? data.message : false;
        state.message_type = 'change_email';
    },

    //email change confirm error
    email_change_confirm_error(state, data) {
        state.loading = false;
        state.status = 'error';
        state.error_message = data.message ? data.message : false;
        state.message_type = 'change_email_confirm';
    },

    //phone change success
    phone_change_success(state, data) {
        state.loading = false;
        state.status = 'success';
        state.success_message = data.message ? data.message : false;
        state.message_type = 'confirm_phone';
    },

    //resend phone change confirm success
    resend_phone_confirm_success(state, data) {
        state.loading = false;
        state.status = 'success';
        state.success_message = data.message ? data.message : false;
        state.message_type = 'confirm_phone';
    },

    //phone change confirm success
    phone_confirm_success(state, data) {
        state.loading = false;
        state.user.phone_verified_at = data.phone_verified_at;
        state.user.phone_code = data.phone_code;
        state.user.phone_number = data.phone_number;

        state.status = 'success';
    },

    //phone change error
    phone_change_error(state, data) {
        state.loading = false;
        state.status = 'error';
        state.error_message = data.message ? data.message : false;
        state.message_type = 'change_phone';
    },

    //resend phone change confirm error
    resend_phone_confirm_error(state, data) {
        state.loading = false;
        state.status = 'error';
        state.error_message = data.message ? data.message : false;
        state.message_type = 'confirm_phone';
    },

    //phone change confirm error
    phone_confirm_error(state, data) {
        state.loading = false;
        state.status = 'error';
        state.error_message = data.message ? data.message : false;
        state.message_type = 'confirm_phone';
    },

    //password recover success
    password_recover_success(state, data) {
        state.loading = false;
        state.status = 'success';
        state.success_message = data.message ? data.message : false;
        state.message_type = 'confirm';
        state.confirmType = data.type;
        state.confirmEmail = data.email;
    },

    //sign up success
    sign_up_success(state, data) {
        state.loading = false;
        state.status = 'success';
        state.success_message = data.message ? data.message : false;
        state.message_type = 'confirm';
        state.confirmType = data.type;
        state.confirmEmail = data.email;

        // state.frontend_notify.title = data.message ? data.message : '';
        // state.frontend_notify.type = 'success';
    },

    //password recover confirm success
    password_recover_confirm_success(state, data) {
        state.loading = true;
        state.status = 'success';
        state.token = data.token;
        state.success_message = data.message ? data.message : false;
        state.message_type = 'forgot_password_confirm';

        state.frontend_notify.title = data.message ? data.message : '';
        state.frontend_notify.type = 'success';
    },

    //password recover error
    password_recover_error(state, data) {
        state.loading = false;
        state.status = 'error';
        state.error_message = data.message ? data.message : false;
        state.message_type = 'forgot_password';
    },

    //sign up error
    sign_up_error(state, data) {
        state.loading = false;
        state.status = 'error';
        state.error_message = data.message ? data.message : false;
        state.message_type = 'sign_up';
    },

    //password recover confirm error
    password_recover_confirm_error(state, data) {
        state.loading = false;
        state.status = 'error';
        state.error_message = data.message ? data.message : false;
        state.message_type = 'forgot_password_confirm';
    },

    //resend confirm success
    resend_confirm_success(state, data) {
        state.loading = false;
        state.status = 'success';
        state.success_message = data.message ? data.message : false;
        state.message_type = 'confirm';
        state.confirmType = data.type;
        state.confirmEmail = data.email;
    },

    //resend confirm error
    resend_confirm_error(state) {
        state.loading = false;
        state.status = 'error';
        state.error_message = data.message ? data.message : false;
        state.message_type = 'confirm';
    },

    //confirm error
    confirm_error(state, data) {
        state.loading = false;
        state.status = 'error';
        state.error_message = data.message ? data.message : false;
        state.message_type = 'confirm';
    },

    //confirm success
    confirm_success(state, data) {
        state.loading = false;
        state.status = 'success';

        if (data.type === 'register') {
            state.success_message = data.message ? data.message : false;
            state.message_type = 'login';
        } else if(data.type === 'reset-password' || data.type === 'change-password' || data.type === 'change-email') {
            state.confirmToken = data.token;
        }
    },

    //update two fa success
    update_two_fa_success(state, data) {
        state.loading = false;
        state.status = 'success';
        state.user.two_fa = data.value;
    },

    general_settings_loaded(state) {
        state.loading = false;
        state.status = 'success';
    },

    save_general_settings_success() {
        state.loading = false;
        state.status = 'success';
    },

    //update languages error
    save_general_settings_error(state, data) {
        if (data.message) {
            if (data.message === 'action_prohibited') {
                state.error_message = ('Action prohibited' in state.currentTranslations) ? state.currentTranslations['Action prohibited'] : 'Action prohibited';
            } else {
                state.error_message = data.message;
            }
        } else {
            state.error_message = false;
        }
        state.message_type = 'save_default_pages';
    },

    //languages loaded
    languages_loaded(state, data) {
        state.loading = false;
        state.status = 'success';

        state.languages = data.languages;
    },

    //update languages success
    update_languages_success(state, data) {
        state.loading = false;
        state.status = 'success';

        state.languages = data.languages;
        state.languageMenu = data.active_languages;
    },

    //update languages error
    update_languages_error(state, data) {
        if (data.message) {
            if (data.message === 'action_prohibited') {
                state.error_message = ('Action prohibited' in state.currentTranslations) ? state.currentTranslations['Action prohibited'] : 'Action prohibited';
            } else {
                state.error_message = data.message;
            }
        } else {
            state.error_message = false;
        }
        state.message_type = 'update_language';
    },

    //update translations success
    update_translation_success(state, data) {
        state.loading = false;
        state.status = 'success';

        state.currentTranslations[data.translation.key] = data.translation.name;
    },

    //update translations menu success
    update_translation_menu_success(state, data) {
        state.loading = false;
        state.status = 'success';

        state.sidebarMenuAdminName = data.menus.sidebarMenuAdminName;
        state.sidebarMenuAdmin = data.menus.sidebarMenuAdmin;
        state.profileMenu = data.menus.profileMenu;
        state.searchable = data.searchable;
        state.staredPages = data.staredPages;
    },

    //logout
    logout(state) {
        state.loading = false;
    },

    //logout success
    logout_success(state) {
        state.loading = false;
        state.status = 'success';
        state.token = '';
    },

    //change active user language
    change_active_user_language(state) {
        state.loading = false;
    },

    //active user language changed
    active_user_language_changed(state, data) {
        state.loading = false;
        state.status = 'success';

        state.activeLanguage = data.activeLanguage;
        state.local_active_language_id = data.activeLanguage.id;
        state.currentTranslations = data.currentTranslations;
        state.sidebarMenuAdminName = data.menus.sidebarMenuAdminName;
        state.sidebarMenuAdmin = data.menus.sidebarMenuAdmin;
        state.profileMenu = data.menus.profileMenu;
        state.searchable = data.searchable;
        state.staredPages = data.staredPages;
    },

    //user remove success
    user_remove_success(state, id) {
        const user_index = state.users.findIndex(x => x.id === id);
        state.users.splice(user_index, 1);

        state.usersCount = (state.users).length;
    },

    //user remove success
    SET_PERMISSIONS(state, permissions) {
        state.permissions = permissions;
    },

    CLEAR_MESSAGES(state) {
        state.success_message = false;
        state.error_message = false;
        state.message_type = false;
        state.frontend_notify.title = false;
        state.frontend_notify.text = false;
        state.frontend_notify.type = false;
    },

    // ////////////////////////////////////////////
    // SIDEBAR & UI UX
    // ////////////////////////////////////////////
    UPDATE_SIDEBAR_WIDTH(state, width) {
        state.sidebarWidth = width;
    },

    UPDATE_SIDEBAR_ITEMS_MIN(state, val) {
        state.sidebarItemsMin = val;
    },

    TOGGLE_REDUCE_BUTTON(state, val) {
        state.theme.sidebar_collapsed = val;
    },

    TOGGLE_CONTENT_OVERLAY(state, val) {
        state.bodyOverlay = val;
    },

    TOGGLE_IS_SIDEBAR_ACTIVE(state, value) {
        state.isSidebarActive = value;
    },

    UPDATE_THEME(state, payload) {
        state.theme[payload.key] = payload.value;
    },

    UPDATE_WINDOW_BREAKPOINT(state, val) {
        state.breakpoint = val;
    },

    UPDATE_WINDOW_WIDTH(state, width) {
        state.windowWidth = width;
    },

    // ////////////////////////////////////////////
    // COMPONENT
    // ////////////////////////////////////////////

    // VxAutoSuggest
    UPDATE_STARED_PAGE(state, payload) {
        // find item index in search list state
        const index = state.searchable.findIndex((item) => item.id === payload.id && item.type === payload.type);
        // update the main list
        state.searchable[index].stared = payload.stared;

        // if val is true add it to stared else remove
        if (payload.stared) {
            state.staredPages.push(state.searchable[index])
        } else {
            // find item index from stared pages
            const index = state.staredPages.findIndex((item) => item.id === payload.id);
            // remove item using index
            state.staredPages.splice(index, 1);
        }
    },

    // The Navbar
    ARRANGE_STARED_PAGES_LIMITED(state, list) {
        const staredPagesMore = state.staredPages.slice(10);
        state.staredPages = list.concat(staredPagesMore);
    },

    ARRANGE_STARED_PAGES_MORE(state, list) {
        let downToUp = false;
        let lastItemInStarredLimited = state.staredPages[10];
        const starredPagesLimited = state.staredPages.slice(0, 10);
        state.staredPages = starredPagesLimited.concat(list);
        state.staredPages.slice(0, 10).map((i) => {
            if (list.indexOf(i) > -1) downToUp = true
        });

        if (!downToUp) {
            state.staredPages.splice(10, 0, lastItemInStarredLimited)
        }
    },

    REMOVE_STATISTICS_BLOCK(state, block_id) {
        const index = state.statisticsLayoutBlocks.findIndex(item => item.i === block_id);
        state.statisticsLayoutBlocks.splice(index, 1);
    },

    ADD_STATISTICS_BLOCK(state, block_id) {
        const index = state.tmpStatisticsLayoutBlocks.findIndex(item => item.i === block_id);
        const item = state.tmpStatisticsLayoutBlocks[index];

        item.i = state.statisticsLayoutBlocks.length + 1;
        state.statisticsLayoutBlocks.push(item);
    },
    SET_HEALTH_SCORES_BY_ACCOUNT(state, payload) {
        state.healthScoresByAccount = payload || {};
    },
};

export default mutations
